import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import tenantService from '../../services/tenantService';
import { useTheme } from '../../contexts/ThemeContext';

const TenantSelector = ({ value, onChange, disabled, required }) => {
  const { user } = useAuth();
  const { darkMode } = useTheme();
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?.role !== 'admin') return;
    tenantService.getTenants()
      .then(data => setTenants(Array.isArray(data) ? data.filter(t => t.isActive !== false) : []))
      .catch(() => setTenants([]))
      .finally(() => setLoading(false));
  }, [user?.role]);

  // Only render for super admins
  if (!user || user.role !== 'admin') return null;

  return (
    <div>
      <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
        Tenant
      </label>
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value || null)}
        disabled={disabled || loading}
        required={required}
        className={`w-full px-3 py-2 rounded border ${
          darkMode
            ? 'bg-gray-700 border-gray-600 text-white'
            : 'bg-white border-gray-300 text-gray-900'
        } focus:ring-2 focus:ring-blue-500`}
      >
        <option value="">No Tenant (Global)</option>
        {tenants.map((t) => (
          <option key={t._id} value={t._id}>
            {t.name} ({t.subdomain})
          </option>
        ))}
      </select>
    </div>
  );
};

export default TenantSelector;
